<style lang="scss" scoped>
.sub-header {
  display: flex;
  padding: 0 32px;
  color: #666;
  font-size: 14px;

  .question-num {
    flex: 1;
    line-height: 60px;
  }
}

.refresh-btn {
  float: right;
  height: 60px;
  line-height: 60px;

  > label {
    display: inline-block;
    margin-left: 10px;
    color: $color-theme;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      font-weight: bold;
    }
  }
}

.chart {
  margin: 0 60px 0;
}

#scoreSpreadChart {
  height: 300px;
}
</style>

<template>
  <div>
    <div class="sub-header">
      <div class="question-num">
        <span>题号：</span>
        <el-select value-key="num" style="width:180px;" v-model="currentQuestion">
          <el-option v-for="(q, i) in questionList" :key="i" :label="`${q.bigNum || ''}${q.smallNum || ''}`" :value="q">
            <join-topic :direction="'row'" :fontSize="14" :texts="[q.bigNum, q.smallNum]" :nullText="q.question" />
          </el-option>
        </el-select>
      </div>
      <div class="refresh-btn">
        <span>数据统计截止到 {{ updated_at }}</span>
        <label @click="getScoreSpread()">刷新</label>
      </div>
    </div>

    <div class="chart">
      <div id="scoreSpreadChart"></div>
    </div>

    <div style="margin: 16px 32px">
      <el-table size="small" max-height="750px" border :data="distribution_table">
        <el-table-column fixed="left" min-width="100px" label="老师姓名" prop="teacherName" align="center"></el-table-column>
        <el-table-column fixed="left" label="批阅角色" prop="teacherType" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.teacherType == 'FIRST'">批阅老师</span>
            <span v-else-if="scope.row.teacherType == 'SECOND'">仲裁老师</span>
            <span v-else-if="scope.row.teacherType == 'THIRD'">三评老师</span>
            <span v-else-if="scope.row.teacherType == 'LEADER'">批阅组长</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column fixed="left" label="总份数" prop="total" align="center"></el-table-column>
        <el-table-column v-for="(s, i) in score_group" :key="i" :label="i != score_group.length - 1
          ? `[${s[0]},${s[1]})`
          : `[${s[0]},${s[1]}]`
          " align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.counts[i] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/title";
import "echarts/lib/component/markLine";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/dataZoomInside";
import "echarts/lib/component/tooltip";
import { getExamQuestions } from "@/api/exam/marking";
import util from "@/utils/util";
import { gradingApi } from '@/v2/utils/api'
import JoinTopic from "@/components/JoinTopic";
export default {
  components: {
    JoinTopic
  },
  data () {
    return {
      ifCanExport: true,
      seriesList: [],
      teacherNameList: [],
      examName: "",
      subjectName: "",
      gradeName: "",
      currentQuestion: {},
      questionList: [],
      currentType: 1,
      avgScore: "",
      teacherScore: [],
      qualityTableData: [],
      distribution_curve: [],
      distribution_table: [],
      score_group: [],
      updated_at: "",
      loading: false
    };
  },
  props: {
    isClassMark: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    currentQuestion () {
      this.getScoreSpread();
    }
  },

  mounted () {
    this.getQuestionList();
  },

  methods: {
    async getQuestionList () {
      let res = await getExamQuestions({
        examId: this.$route.params.id,
        teacherId: ''
      });
      if (res.success) {
        this.questionList = res.body;
        if (this.questionList.length > 0) {
          this.currentQuestion = this.questionList[0];
        }
      } else {
        this.$message.error(res.message);
      }
    },

    async getScoreSpread () {
      this.loading = true;
      let params = {
        examId: this.$route.params.id,
        schoolId: this.$route.query.schoolId,
        question: this.currentQuestion.question,
        num: this.currentQuestion.num
      }
      let method = 'queryScoreSpread'
      if (this.$route.query.isRegion + '' === 'true') {
        params.regionId = this.$route.query.regionId
        method = 'getScoreSpread'
      }

      let res = await gradingApi[method](params)
      this.loading = false;
      if (res.code == 200) {
        this.ifCanExport = true;
        this.distribution_curve = res.result.distribution_curve;
        const list = res.result.distribution_table;
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          let className = ''
          if (this.isClassMark) {
            className = element.gradingClasses ? element.gradingClasses.map(s => s.className).join('、') : ''
          }

          element.teacherName = className + (className.length > 0 ? '-' : '') + (element.teacherName ? element.teacherName : element.teacherId.substring(element.teacherId.length - 6) + '(已删除)')
        }
        this.score_group = res.result.score_group;
        if (res.result.date) {
          this.updated_at = util.formatDate(res.result.date, "ymdhis");
        } else {
          this.updated_at = "";
        }
        this.distribution_table = list
        this.teacherNameList = res.result.distribution_table.map(
          t => t.teacherName
        );
        this.seriesList = res.result.distribution_table.map(t => ({
          name: t.teacherName,
          data: t.counts,
          type: "line"
        }));
        this.drawScoreSpread();
      } else {
        this.ifCanExport = false;
        this.distribution_curve = [];
        this.distribution_table = [];
        this.score_group = [];
        this.teacherNameList = [];
        this.seriesList = [];
        this.drawScoreSpread();
        this.$message.error(res.message);
      }
    },

    drawScoreSpread () {
      let option = {
        legend: {
          type: "scroll",
          top: 30,
          selectedMode: true,
          data: ["全部", ...this.teacherNameList]
        },
        grid: {
          left: "5%",
          right: "6%",
          top: 90,
        },
        title: {
          left: "center",
          text: "批阅老师评分分布曲线"
        },
        dataZoom: [
          {
            show: this.distribution_curve.length > 30 ? true : false,
            start: 0,
            end: Math.ceil((30 / this.distribution_curve.length) * 100),
            bottom: 30
          }
        ],
        tooltip: {
          show: true,
          formatter: "{a} <br />{b} : {c}份"
        },
        xAxis: {
          name: "分数区间",
          type: "category",
          data: this.distribution_curve.map((d, i) =>
            i != this.distribution_curve.length - 1
              ? `[${d.group[0]},${d.group[1]})`
              : `[${d.group[0]},${d.group[1]}]`
          ),
          boundaryGap: false
        },
        yAxis: {
          name: "份数",
          type: "value"
        },
        series: [
          {
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#518bdb"
                }
              }
            },
            data: this.distribution_curve.map(d => d.count),
            type: "line",
            name: "全部"
          },
          ...this.seriesList
        ]
      };
      const dom = document.getElementById('scoreSpreadChart')
      let chart = echarts.getInstanceByDom(dom)
      if (chart) {
        chart.dispose()
      }
      let lineChart = echarts.init(dom);
      // console.log(JSON.stringify(option))
      this.$nextTick(() => {
        lineChart.setOption(option);
        lineChart.resize();
      });
    }
  }
};
</script>
